import React from "react";
import "./ReportPreviewChrome.css";

export const REPORT_PREVIEW_HELP_TEXT =
  "On-screen preview is optimized for mobile review. Export PDF saves or shares a PDF from the report data.";

export function ReportPreviewFrame({ children, className = "" }) {
  return (
    <div
      className={["report-preview-frame", className].filter(Boolean).join(" ")}
    >
      {children}
    </div>
  );
}

export function ReportPreviewChrome({ helpText = REPORT_PREVIEW_HELP_TEXT, children }) {
  return (
    <div className="report-preview-chrome">
      <p className="report-preview-help">{helpText}</p>
      {children ? <div className="report-preview-toolbar">{children}</div> : null}
    </div>
  );
}
